import React, { useContext } from 'react'
import { MedPlanContext, ChangePresentContext } from '../../SingleEvent'
import { Grid, TextField } from '@mui/material'

const Safeguarding = () => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12}>
      <TextField
        label="Safeguarding Considerations"
        fullWidth
        multiline
        value={medPlan?.safeguarding}
        onChange={(e) => {
          setMedPlan((prev) => ({
            ...prev,
            safeguarding: e.target.value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        InputLabelProps={{
          shrink: !!medPlan?.safeguarding,
        }}
        autoComplete="off"
        name="medplan-safeguarding"
      />
    </Grid>
  )
}

export default React.memo(Safeguarding)
